export const dateFormatter = {
    toShortDate(date) {
        const inputDate = date instanceof Date ? date : new Date(date);

        // Handle invalid dates
        if (isNaN(inputDate.getTime())) {
            return "";
        }

        return inputDate.toLocaleDateString("fr-FR");
    },

    toHumanDate(date) {
        // Convert string to Date if needed
        const inputDate = date instanceof Date ? date : new Date(date);
        const now = new Date();

        // Handle invalid dates
        if (isNaN(inputDate.getTime())) {
            return "";
        }

        // Get time differences
        const diffMs = now - inputDate;
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const diffWeeks = Math.floor(diffDays / 7);

        // Check if date is today
        const isToday = inputDate.toDateString() === now.toDateString();

        if (isToday || diffDays === 0) {
            // Format time as HH:mm
            return inputDate.toLocaleTimeString("fr-FR", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: false,
            });
        } else if (diffDays === 1) {
            return "hier";
        } else if (diffDays < 7) {
            return `Il y a ${diffDays} jours`;
        } else {
            return `Il y a ${diffWeeks} semaine${diffWeeks > 1 ? "s" : ""}`;
        }
    },

    toLocaleString(date) {
        return date.toLocaleString("fr-FR");
    },
};

